import { useCart } from "../../context/CartContext";

export default function NextCart() {
    const {
        nextCart = [],
        moveToCart,
        removeFromNextCart,

        isMovingToCart,
    } = useCart();


    if (!nextCart.length) {
        return null;
    }


    return (
        <section className="next-cart">

            <div className="next-cart-items">

                {nextCart.map((item) => {

                    console.log(
                        "NEXT CART VARIATION:",
                        item.selectedVariation
                    );

                    const variation =
                        item.selectedVariation;

                    const variationId =
                        variation?.variationId ?? null;

                    const giftId =
                        item.selectedGift?.id ?? null;


                    const isMoving =
                        isMovingToCart(
                            item.id,
                            variationId,
                            giftId
                        );


                    const isInStock =
                        variation?.inStock === true ||
                        variation?.inStock === 1 ||
                        variation?.inStock === "1";

                    const isExpired =
                        variation?.isExpired === true ||
                        variation?.isExpired === 1 ||
                        variation?.isExpired === "1";

                    const isOutOfStock =
                        variation?.inStock !== true ||
                        variation?.isExpired === true;





                    const price =
                        variation?.finalPrice ??
                        variation?.salePrice ??
                        variation?.price ??
                        item.finalPrice ??
                        item.salePrice ??
                        item.price ??
                        0;


                    return (
                        <article
                            key={[
                                item.id,
                                variationId ??
                                "no-variation",
                                giftId ??
                                "no-gift",
                            ].join("-")}
                            className={`next-cart-item ${isOutOfStock
                                ? "is-out-of-stock"
                                : ""
                                }`}
                        >

                            <div className="next-cart-image">

                                {isOutOfStock && (
                                    <span className="out-of-stock-badge">
                                        {isExpired
                                            ? "منقضی شده"
                                            : "ناموجود"}
                                    </span>
                                )}

                                <img
                                    src={
                                        item.image ||
                                        item.thumbnail ||
                                        "/images/product-placeholder.png"
                                    }
                                    alt={item.name}
                                    loading="lazy"
                                />

                            </div>


                            <div className="next-cart-info">

                                <h3>
                                    {item.name}
                                </h3>


                                {variation?.attributes && (
                                    <div className="next-cart-attributes">

                                        <span>
                                            {variation.attributes.attribute}:
                                        </span>

                                        <strong>
                                            {variation.attributes.value}
                                        </strong>

                                    </div>
                                )}


                                <strong className="next-cart-price">

                                    {price.toLocaleString(
                                        "en-US"
                                    )}

                                    <span>
                                        {" "}تومان
                                    </span>

                                </strong>


                                <div
                                    className={
                                        isOutOfStock
                                            ? "stock-out"
                                            : "stock-in"
                                    }
                                >
                                    {isOutOfStock
                                        ? "× ناموجود"
                                        : "✓ موجود"}
                                </div>

                            </div>


                            <div className="next-cart-actions">

                                <button
                                    type="button"
                                    className="move-to-cart-btn"
                                    disabled={isMoving}
                                    onClick={() =>
                                        moveToCart(
                                            item.id,
                                            variationId,
                                            giftId
                                        )
                                    }
                                >
                                    {isMoving ? (
                                        <span className="button-spinner" />
                                    ) : (
                                        "افزودن به سبد خرید"
                                    )}
                                </button>


                                <button
                                    type="button"
                                    className="remove-next-cart-btn"
                                    onClick={() =>
                                        removeFromNextCart(
                                            item.id,
                                            variationId,
                                            giftId
                                        )
                                    }
                                >
                                    ×
                                </button>

                            </div>

                        </article>
                    );
                })}

            </div>

        </section>
    );
}